module.exports = __webpack_public_path__ + "img/full-size.1484139f.svg";